<template>
  <td>
    <div class="row">
      <div class="card" style="box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2); cursor: default;">
        <div data-test="announcement" class="card-body p-3 fs-sm">
          <div data-test="announcement_title" class="text-heading">
            <div class="text-truncate fw-semibold">
              {{ message.title.slice(0, 100) }}
              <span v-if="message.title.length > 100" class="ms-n1">...</span>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <div data-test="announcement_content" class="pt-1 text-heading card-text no-mb">
              <span v-html="message.content.slice(0, 170)"></span>
              <span v-if="network.can.send_message" class="text-primary fw-bold pointer" @click="showMessagePreview(message)">
                {{ message.sent === true ? $t('CardSmall.read-more') : $t('see-preview') }}
              </span>
              <span v-else class="text-primary fw-bold pointer" @click="viewMessage(message)">
                {{ $t('CardSmall.read-more') }}
              </span>
            </div>
            <!--Scheduled messages-->
            <div v-if="this.view == 'scheduled'" class="text-center mt-n2">
              <span class='rounded d-inline fs-6 d-block py-1 px-3' style="background-color: #D9D9D9; color: #5C6D80;">
                <strong>{{ utcToScheduledTime(message.scheduled_on).format('MMM D, YYYY - hh:mm A') }}</strong>
                <strong v-if="message.timezone"><br />{{ showLocalTimezone ? textFormat(local_timezone) : textFormat(message.timezone) }}</strong>
              </span><br />
              <span class="fw-bold fs-5 d-block mt-n1" style="display: inline-block;">
                <a v-if="message.can.update" :href="$route.path + '/' + message.id + '/edit'" data-test="edit_scheduled" style="text-decoration: none;">
                  {{ $t('edit') }}
                </a>
                <span v-if="message.can.update && message.can.delete" class="fw-normal text-secondary fs-4 px-3">&vert;</span>
                <span v-if="message.can.delete" class="text-danger pointer" data-test="delete_scheduled" @click="deleteMessage(message)">
                  {{ $t('network.delete') }}
                </span>
              </span>
            </div>
            <div v-else class="text-center mt-n2">
              <!--Drafted messages-->
              <span v-if="this.view == 'drafts'">
                <span class="fw-bold fs-5 d-block" style="display: inline-block; margin-top: 0.75rem;">
                  <a v-if="message.can.update" :href="$route.path + '/' + message.id + '/edit'" data-test="edit_drafted" style="text-decoration: none;">
                    {{ $t('edit') }}
                  </a>
                  <span v-if="message.can.update && message.can.delete" class="fw-normal text-secondary fs-4 px-3">&vert;</span>
                  <span v-if="message.can.delete" class="text-danger pointer" data-test="delete_drafted" @click="deleteMessage(message)">
                    {{ $t('network.delete') }}
                  </span>
                </span>
              </span>
              <!--Sent messages-->
              <span v-if="this.view == 'sent'">
                <span class="fw-bold fs-5 d-block" style="display: inline-block; margin-top: 1.2rem;">
                  <button class="btn btn-outline-primary btn-sm mt-0" style="border: 2px solid;"
                  @click="showDetailsModal = !showDetailsModal">
                    Details
                  </button>
                  <span class="fw-normal text-secondary fs-4 px-3">&vert;</span>
                  <span data-test="reuse_announcement" class="fw-bold fs-5 text-primary pointer" @click="reuseMessage(message)">
                    Reuse
                  </span>
                </span>
              </span>
            </div>
          </div>
          <div v-if="this.view == 'drafts' || this.view == 'scheduled'">
            <div class="text-muted fs-xs d-inline">
              Edited by {{ message.updated_by }} |
              {{ utcToLocal(message.updated_at).format('MMM D, YYYY - hh:mm A') }}
            </div>
          </div>
          <!--Sent messages-->
          <div v-if="this.view == 'sent'">
            <div class="text-muted fs-xs d-inline">
              Sent by {{ message.updated_by }} |
              {{ utcToLocal(message.scheduled_on ?? message.created_at).format('MMM D, YYYY - hh:mm A') }}
            </div>
          </div>
        </div>
      </div>
      <b-modal :id="'messagePreviewModal'+message.id" hide-footer no-stacking size="lg" :title="message.title" body-class="p-0">
        <p class="mb-2" v-html="message_preview_html"></p>
      </b-modal>
      <b-modal v-model="showDetailsModal" hide-footer hide-header no-close-on-backdrop size="xl" @shown="showBounceStats = true">
        <span role="button" class="close float-end fs-4 mt-n2 me-n1" @click="showDetailsModal = !showDetailsModal, showBounceStats = false">
          <span aria-hidden="true"><i class="fa fa-times"></i></span>
        </span>
        <h5 class="px-2">
          This announcement has {{ message.email_sent }} sends and {{ message.email_delivered }} ({{ message.percentage_delivered }}%) deliveries.
          Below, you can view its performance across various parameters.
        </h5>
        <div class="card border-0">
          <div class="card-body p-2">
            <!-- Vertical tabs -->
            <div class="row">
              <div class="col-3 ps-0">
                <ul class="nav nav-tabs flex-column pointer" role="tablist">
                  <li class="nav-item">
                    <a href="" data-bs-target="#bounces" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none active" @click="showBounceStats = true">
                      Bounces
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="" data-bs-target="#spam" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none" @click="showComplaintStats = !showComplaintStats">
                      Spam
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="" data-bs-target="#rejects" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none" @click="showRejectStats = !showRejectStats">
                      Rejects
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="" data-bs-target="#opens" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none" @click="showOpenStats = !showOpenStats">
                      {{ $t('opens') }}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="" data-bs-target="#clicks" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none" @click="showLinkStats = !showLinkStats">
                      Clicks
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="" data-bs-target="#history" data-bs-toggle="tab" role="tab"
                      class="nav-link custom-tab-bg text-decoration-none">
                      Edit history
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-9">
                <div id="myTabContent" class="tab-content">
                  <div id="bounces" role="tabpanel" aria-labelledby="bounces-tab" class="tab-pane fade" :class="{ 'show active': showBounceStats }">
                    <h5>The announcement was not delivered, either temporarily or permanently.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <div v-if="!busy">
                      <table v-if="bounce_stats.length" class="table table-striped table-condensed table-bordered table-hover mt-3">
                        <thead>
                          <tr class="text-center">
                            <td>Name</td>
                            <td>Email</td>
                            <td>Bounce type</td>
                            <td>Notes</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(event, index) in bounce_stats" :key="index" class="text-center">
                            <td style="min-width: 150px;">{{ event.name }}</td>
                            <td style="min-width: 150px;">{{ event.email }}</td>
                            <td>{{ event.bounce_type }}</td>
                            <td v-html="event.notes"></td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="alert alert-info text-center mt-2 mb-0">
                        {{ $t('network.member.noResultsToShow') }}
                      </div>
                    </div>
                    <div v-else class="row text-center mt-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                  <div id="spam" role="tabpanel" aria-labelledby="spam-tab" class="tab-pane fade">
                    <h5>The announcement has been received but marked as spam. The recipients should be removed from the mailing list.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <div v-if="!busy">
                      <table v-if="complaint_stats.length" class="table table-striped table-condensed table-bordered table-hover mt-3">
                        <thead>
                          <tr class="text-center">
                            <td>Name</td>
                            <td>Email</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(event, index) in complaint_stats" :key="index" class="text-center">
                            <td>{{ event.name }}</td>
                            <td>{{ event.email }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="alert alert-info text-center mt-2 mb-0">
                        {{ $t('network.member.noResultsToShow') }}
                      </div>
                    </div>
                    <div v-else class="row text-center mt-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                  <div id="rejects" role="tabpanel" aria-labelledby="rejects-tab" class="tab-pane fade">
                    <h5>The announcement was not delivered because Amazon SES determined that it contained a virus.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <div v-if="!busy">
                      <table v-if="reject_stats.length" class="table table-striped table-condensed table-bordered table-hover mt-3">
                        <thead>
                          <tr class="text-center">
                            <td>Name</td>
                            <td>Email</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(event, index) in reject_stats" :key="index" class="text-center">
                            <td>{{ event.name }}</td>
                            <td>{{ event.email }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="alert alert-info text-center mt-2 mb-0">
                        {{ $t('network.member.noResultsToShow') }}
                      </div>
                    </div>
                    <div v-else class="row text-center mt-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                  <div id="opens" role="tabpanel" aria-labelledby="opens-tab" class="tab-pane fade">
                    <h5>Analyze email access over different time periods.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <b-overlay :show="busy">
                      <div class="row">
                        <div class="col-12">
                          <b-form-group class="m-1 mb-3">
                            <label class="fw-bold text-secondary">{{ $t('network.networkForm.groupBy') }}</label>
                              <v-select
                                v-model="open_hits_chart_group_by_option"
                                :options="group_by_options_open"
                                :placeholder="$t('network.networkForm.groupBy')"
                                :clearable=false
                                @input="renderOpenHitsChart"
                              ></v-select>
                          </b-form-group>
                        </div>
                        <div v-if="loaded && !noOpenData" class="col-12">
                          <span v-if="open_hits_chart_group_by_option == 'HOUR'">
                            This option presents email open rates with precision, displaying the exact times emails were opened.
                          </span>
                          <span v-if="open_hits_chart_group_by_option == 'DAY'">
                            This option organizes email open rates in one-hour intervals throughout the day.
                          </span>
                          <span v-if="open_hits_chart_group_by_option == 'WEEK'">
                            This option categorizes email open rates based on the day they were opened.
                          </span>
                        </div>
                        <div v-if="loaded && !noOpenData" class="col-12 mt-3 rounded msg-stats" style="background-color: #D9D9D9;">
                          <apexchart
                            class="mt-4"
                            type="bar"
                            height="500"
                            :options="open_hits_chart_options"
                            :series="open_hits_chart_series"
                          ></apexchart>
                        </div>
                        <span v-if="loaded && noOpenData" class="text-center mt-3 fs-5">
                          No data.
                        </span>
                      </div>
                    </b-overlay>
                    <div v-if="!loaded && open_hits_chart_group_by_option != 'Choose an option'" class="text-center mt-4 mb-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                  <div id="clicks" role="tabpanel" aria-labelledby="clicks-tab" class="tab-pane fade">
                    <h5>Analyze access to email links over different time periods.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <b-overlay :show="busy">
                      <div class="row">
                        <div v-if="link_chart_link_options.length > 0" class="col-12">
                          <b-form-group class="m-1 mb-3">
                            <label class="fw-bold text-secondary">Select link</label>
                              <v-select
                                id="link_hits_chart_selected_link_option"
                                v-model="link_hits_chart_selected_link_option"
                                data-test="link_hits_chart_selected_link_option"
                                :options="link_chart_link_options"
                                label="slug"
                                value="id"
                                :clearable=false
                                @input="renderLinkHitsChart"
                              ></v-select>
                          </b-form-group>
                        </div>
                        <div v-if="link_chart_link_options.length > 0" class="col-12">
                          <b-form-group class="m-1 mb-3">
                            <label class="fw-bold text-secondary">{{ $t('network.networkForm.groupBy') }}</label>
                              <v-select
                                v-model="link_hits_chart_group_by_option"
                                :options="group_by_options_link"
                                :placeholder="$t('network.networkForm.groupBy')"
                                :clearable=false
                                @input="renderLinkHitsChart"
                              ></v-select>
                          </b-form-group>
                        </div>
                        <div v-if="link_hits_chart_selected_link_option.length && loaded && !noLinkData" class="col-12">
                          <span v-if="link_hits_chart_group_by_option == 'HOUR'">
                            This option presents link click rates with precision, displaying the exact times links were clicked.
                          </span>
                          <span v-if="link_hits_chart_group_by_option == 'DAY'">
                            This option organizes link click rates in one-hour intervals throughout the day.
                          </span>
                          <span v-if="link_hits_chart_group_by_option == 'WEEK'">
                            This option categorizes link click rates based on the day they were clicked.
                          </span>
                        </div>
                        <div v-if="loaded && !noLinkData" class="col-12 mt-3 rounded msg-stats" style="background-color: #D9D9D9;">
                          <apexchart
                            class="mt-4"
                            type="bar"
                            height="500"
                            :options="link_hits_chart_options"
                            :series="link_hits_chart_series"
                          ></apexchart>
                        </div>
                        <span v-if="loaded && noLinkData && link_hits_chart_selected_link_option.length > 0" class="text-center mt-3 fs-5">
                          No data.
                        </span>
                        <span v-if="link_chart_link_options.length == 0" class="text-center mt-2 fs-5">
                          The announcement doesn't contain links.
                        </span>
                      </div>
                    </b-overlay>
                    <div v-if="!loaded && link_hits_chart_selected_link_option.length > 0" class="text-center mt-4 mb-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                  <div id="history" role="tabpanel" aria-labelledby="history-tab" class="tab-pane fade">
                    <h5>See the announcement's edit history.</h5>
                    <hr style="opacity: 0.7; height: 2px;" />
                    <div v-if="!busy">
                      <table v-if="message.history && message.history.length" class="table table-striped table-condensed table-bordered table-hover mt-3">
                        <thead>
                          <tr class="text-center">
                            <td>Editor</td>
                            <td>Date</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(editor, i) in message.history" :key="i" class="text-center">
                            <td>{{ editor.name }}</td>
                            <td>{{ utcToLocal(editor.date).format('MMM D, YYYY - hh:mm A') }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-else class="alert alert-info text-center mt-2 mb-0">
                        {{ $t('network.member.noResultsToShow') }}
                      </div>
                    </div>
                    <div v-else class="row text-center mt-3">
                      <lottie-player
                        autoplay
                        loop
                        speed="2.5"
                        src="/img/animations/custom_loader.json"
                        style="height: 130px;"
                        >
                      </lottie-player>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </td>
</template>
<script>
import moment from 'moment';
import truncate from 'lodash/truncate';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    vSelect,
    apexchart: VueApexCharts,
  },
  props: {
    message: {
      type: [Array, Object],
      default: null,
    },
    network: {
      type: [Array, Object],
      default: null,
    },
    show_actions: {
      type: Boolean,
      default: true,
    },
    character_limit: {
      type: Number,
      default: null,
    },
    displayDeliverStats: {
      type: Boolean,
      default: true,
    },
    view: {
      type: String,
      default: null,
    },
    local_timezone: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      loaded: false,
      colors: ['rgba(0, 97, 182, 0.82)'],
      message_status: '',
      message_preview: false,
      message_preview_html: '',
      pending: "<span class='badge bg-faded-secondary pt-1 text-secondary fs-xs' style='color: #6c757d !important;'><strong><i class='fas fa-hourglass'></i> " + this.$t('ModerationTab.pending') + "</strong><span>",
      sending: "<span class='badge bg-faded-primary pt-1 text-primary fs-xs' style='color: #0d6efd !important;'><strong><i class='fas fa-paper-plane'></i> " + this.$t('Card.sending') + "</strong></span>",
      sent: "<span class='badge bg-faded-success pt-1 text-success fs-xs' style='color: #198754 !important;'><strong><i class='fas fa-check'></i> " + this.$t('Card.sent') + "</strong><span>",
      saved: "<span class='badge bg-faded-warning pt-1 text-warning fs-xs' style='color: #ffc107 !important;'><strong><i class='fas fa-save'></i> Saved</strong><span>",
      scheduled: "<span class='badge bg-faded-primary pt-1 text-primary fs-xs' style='color: #0d6efd !important;'><strong><i class='fa fa-clock'></i></i> Scheduled</strong></span>",
      /* links hits chart */
      showLinkStats: false,
      group_by_options_link: ['HOUR', 'DAY', 'WEEK'],
      link_chart_link_options: [],
      link_hits_chart_group_by_option: 'DAY',
      link_hits_chart_selected_link_option: { id: '', slug: 'Choose an option' },
      link_hits_chart_series: [],
      link_hits_chart_options: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fa-solid fa-download" title="Download"></i>',
            },
            export: {
              csv: {
                filename: 'Click stats',
                headerCategory: 'Clicked at',
              },
              svg: {
                filename: 'Click stats',
              },
              png: {
                filename: 'Click stats',
              },
            },
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 0,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
          dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {
              fontSize: '12px',
              colors: ['#fff'],
            },
          },
        },
        yaxis: {
          title: {
            text: 'Clicks',
          },
        },
        xaxis: {
          title: {
            text: this.utcToLocal(this.message.updated_at).format('MMM D, YYYY'),
          },
          labels: {
            format: 'H:mm',
          },
          type: 'time',
          categories: [],
        },
        legend: {
          position: 'right',
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },
      noLinkData: true,
      /* open stats */
      showOpenStats: false,
      group_by_options_open: ['HOUR', 'DAY', 'WEEK'],
      open_hits_chart_group_by_option: 'Choose an option',
      open_hits_chart_series: [],
      open_hits_chart_options: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fa-solid fa-download" title="Download"></i>',
            },
            export: {
              csv: {
                filename: 'Open stats',
                headerCategory: 'Opened at',
              },
              svg: {
                filename: 'Open stats',
              },
              png: {
                filename: 'Open stats',
              },
            },
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 0,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
          dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {
              fontSize: '12px',
              colors: ['#fff'],
            },
          },
        },
        yaxis: {
          title: {
            text: 'Opens',
          },
        },
        xaxis: {
          title: {
            text: this.utcToLocal(this.message.updated_at).format('MMM D, YYYY'),
          },
          labels: {
            format: 'H:mm',
          },
          type: 'time',
          categories: [],
        },
        legend: {
          position: 'right',
          offsetY: 40,
        },
        fill: {
          opacity: 1,
        },
      },
      noOpenData: true,
      showBounceStats: false,
      showComplaintStats: false,
      showRejectStats: false,
      bounce_stats: [],
      complaint_stats: [],
      reject_stats: [],
      showLocalTimezone: false,
      showDetailsModal: false,
    };
  },
  computed: {
    showableText() {
      let limit = this.character_limit || 300;
      let $message = this.message;
      var content;
      if ($message.type === 'json') {
        var loadDesign = JSON.parse($message.content);
        content = loadDesign.html;
      } else {
        content = $message.content;
      }
      return truncate(content, {
        length: limit, // maximum 30 characters
        separator: /,?\.* +/, // separate by spaces, including preceding commas and periods
      });
    },
  },
  watch: {
    message_preview(){
      this.showMessagePreview(this.message);
    },
    showLinkStats() {
      if (this.showLinkStats) {
        this.getLinks();
      }
    },
    showBounceStats() {
      if (this.showBounceStats) {
        this.getSESstats();
      }
    },
    showComplaintStats() {
      if (this.showComplaintStats) {
        this.getSESstats();
      }
    },
    showRejectStats() {
      if (this.showRejectStats) {
        this.getSESstats();
      }
    },
  },
  mounted() {
    this.messageStatus();
  },
  methods: {
    showMessagePreview(message) {
      this.message.eventAction = 'preview';
      this.$http.post('networks/' + this.network.slug + '/message/preview', message).then(resp => {
        this.message_preview_html = resp.data;
        this.$bvModal.show('messagePreviewModal'+message.id);
      });
    },
    reuseMessage(message) {
      this.$router.push({
        name: 'network-message-create-page',
        params: {
          network: this.network.slug,
          reusedMessage: message
        },
      });
    },
    deleteMessage(message) {
      let msg = this.$t('network.messages.doYouWantToDelete');
      let action = () => {
        this.$http.delete('networks/messages/' + message.id).then(() => {
          this.$swal.fire({
            text: 'Message deleted succesfully',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.$emit('message-deleted', message);
        });
      };
      this.showConfirmPrompt(action, msg);
    },
    /**
     * @define To Check Delivery Percentage and Status based on that
     */
    checkDeliveryPercentage() {
      if (this.message.percentage_delivered === 0) {
        this.message_status = this.pending;
      } else if (this.message.percentage_delivered === 100) {
        this.message_status = this.sent;
      } else {
        this.message_status = this.sending;
      }
    },
    /**
     * @define To Check Message Status and Display
     */
    messageStatus() {
      if (this.message.status === 'save') {
        this.message_status = this.saved;
      } else {
        if (this.message.is_scheduled) {
          let scheduled_time = this.utcToLocal(this.message.scheduled_on).format();
          let current_time = this.utcToLocal(new Date()).format();
          if (current_time >= scheduled_time) {
            this.message_status = this.sent;
          } else {
            this.checkDeliveryPercentage();
            //this.message_status = this.scheduled;
          }
        } else {
          this.checkDeliveryPercentage();
          //this.message_status = this.sent;
        }
      }
    },
    viewMessage(m) {
      this.$router.push('/networks/' + this.network.slug + '/messages/' + m.id);
    },
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    utcToScheduledTime: function (dt) {
      if (this.message.timezone) {
        let zone = moment.tz.zone(this.message.timezone);
        if (zone != null) {
          // change the current value of dt to utc based on the provided timezone

          return moment.utc(dt).tz(this.message.timezone);
        } else {
          // if timezone is not found in moment timezone list then display local one
          this.showLocalTimezone = true;
          return moment.utc(dt).local();
        }
      } else {
        return moment.utc(dt).local();
      }
    },
    textFormat: function (text) {
      return text.replaceAll('_', ' ');
    },
    getLinks() {
      this.$http.get('/networks/message/' + this.message.id + '/get_links').then(resp => {
        if (resp.data.length > 0) {
          this.link_chart_link_options = [
            'All links (combined)',
            ...resp.data
          ];
        }
      });
    },
    getSESstats() {
      this.busy = true;
      this.$http.get('/networks/message/' + this.message.id + '/get_ses_stats').then(resp => {
        this.bounce_stats = resp.data.bounce;
        this.complaint_stats = resp.data.complaint;
        this.reject_stats = resp.data.reject;
        this.busy = false;
      });
    },
    renderLinkHitsChart() {
      var formData = new FormData();
      formData.append('link', this.link_hits_chart_selected_link_option === 'All links (combined)' ? 'combined' : this.link_hits_chart_selected_link_option);
      formData.append('message_id', this.message.id);
      formData.append('group_by', this.link_hits_chart_group_by_option);
      formData.append('date', moment.utc(this.message.updated_at).format('YYYY-MM-DD H:mm:ss'));
      this.link_hits_chart_options.colors = [this.colors[Math.floor(Math.random()*this.colors.length)]];

      this.loaded = false;
      this.$http
        .post('networks/messages/links_hits', formData)
        .then(resp => {
          if (resp.data.data.series[0].data.length > 0) {
            let time = [];
            if (this.link_hits_chart_group_by_option == 'HOUR') {
              resp.data.data.datetime.forEach(element => {
                time.push(moment.utc(element, "H:mm").local().format('H:mm'));
              });
              this.link_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY');
              this.link_hits_chart_options.xaxis.labels.format = 'H:mm';
            } else if (this.link_hits_chart_group_by_option == 'DAY') {
              resp.data.data.datetime.forEach(element => {
                time.push(moment.utc(element, "h").local().format('H:mm'));
              });
              this.link_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY');
              this.link_hits_chart_options.xaxis.labels.format = 'H:mm';
            } else { // WEEK
              resp.data.data.datetime.forEach(element => {
                time.push(moment(element, 'YYYY-MM-DD H:mm:ss').format('MMM DD, YYYY'));
              });
              this.link_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY')+' • '+ this.utcToLocal(this.message.updated_at).add(1, 'week').format('MMM D, YYYY');
              this.link_hits_chart_options.xaxis.labels.format = 'MMM D, YYYY';
            }
            this.link_hits_chart_options.xaxis.categories = Object.values(time);
            this.link_hits_chart_series = resp.data.data.series;
            resp.data.data.series[0].data.forEach(element => {
              if (this.link_hits_chart_group_by_option == 'HOUR') {
                element['x'] = moment.utc(element['x'], "H:mm").local().format('H:mm');
              } else if (this.link_hits_chart_group_by_option == 'DAY') {
                element['x'] = moment.utc(element['x'], "h").local().format('H:mm');
              } else { // WEEK
                element['x'] = moment(element['x'], 'YYYY-MM-DD H:mm:ss').format('MMM DD, YYYY');
              }
            });
            this.noLinkData = false;
          } else {
            this.noLinkData = true;
            this.busy = false;
            this.loaded = true;
          }
        })
        .then(() => {
          this.busy = false;
          this.loaded = true;
        })
        .catch(() => {
          this.busy = false;
        });
    },
    renderOpenHitsChart() {
      var formData = new FormData();
      formData.append('message_id', this.message.id);
      formData.append('group_by', this.open_hits_chart_group_by_option);
      formData.append('date', moment.utc(this.message.updated_at).format('YYYY-MM-DD H:mm:ss'));
      this.open_hits_chart_options.colors = [this.colors[Math.floor(Math.random()*this.colors.length)]];

      this.loaded = false;
      this.$http
        .post('networks/messages/opens_hits', formData)
        .then(resp => {
          if (resp.data.data.series[0].data.length > 0) {
            let time = [];
            if (this.open_hits_chart_group_by_option == 'HOUR') {
              resp.data.data.datetime.forEach(element => {
                time.push(moment.utc(element, "H:mm").local().format('H:mm'));
              });
              this.open_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY');
              this.open_hits_chart_options.xaxis.labels.format = 'H:mm';
            } else if (this.open_hits_chart_group_by_option == 'DAY') {
              resp.data.data.datetime.forEach(element => {
                time.push(moment.utc(element, "h").local().format('H:mm'));
              });
              this.open_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY');
              this.open_hits_chart_options.xaxis.labels.format = 'H:mm';
            } else { // WEEK
              resp.data.data.datetime.forEach(element => {
                time.push(moment(element, 'YYYY-MM-DD H:mm:ss').format('MMM DD, YYYY'));
              });
              this.open_hits_chart_options.xaxis.title.text = this.utcToLocal(this.message.updated_at).format('MMM D, YYYY')+' • '+ this.utcToLocal(this.message.updated_at).add(1, 'week').format('MMM D, YYYY');
              this.open_hits_chart_options.xaxis.labels.format = 'MMM D, YYYY';
            }
            this.open_hits_chart_options.xaxis.categories = Object.values(time);
            this.open_hits_chart_series = resp.data.data.series;
            resp.data.data.series[0].data.forEach(element => {
              if (this.open_hits_chart_group_by_option == 'HOUR') {
                element['x'] = moment.utc(element['x'], "H:mm").local().format('H:mm');
              } else if (this.open_hits_chart_group_by_option == 'DAY') {
                element['x'] = moment.utc(element['x'], "h").local().format('H:mm');
              } else { // WEEK
                element['x'] = moment(element['x'], 'YYYY-MM-DD H:mm:ss').format('MMM DD, YYYY');
              }
            });
            this.noOpenData = false;
          } else {
            this.noOpenData = true;
            this.busy = false;
            this.loaded = true;
          }
        })
        .then(() => {
          this.busy = false;
          this.loaded = true;
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>
<style scoped>
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.swal2-timer-progress-bar {
  background-color: #198754;
}
.no-mb p {
  margin-bottom: 0 !important;
}
.nav-tabs .nav-link.custom-tab-bg.active {
  background-color: #005f9a !important;
  color: white !important;
}
</style>
